import axios from "axios";

import AppButton from "components/app-button";
import AppProductCardDto from "dto/components/app-product-card-dto";
import AppClientVideoModal from "./app-client-video-modal";
import { useCallback, useMemo, useState } from "react";

import PlayIcon from "assets/images/components/app-product-card/play-icon.svg";
import classNames from "common/class-names";

const AppProductCard = ({ image, title, description, link, videoUrl, price, priceWithCode, fixedPrice }: AppProductCardDto) => {
	const [isModalOpen, setIsModalOpen] = useState(false);

	const handleClick = () => downloadPDF(link, title);

	const downloadPDF = async (url: string, filename: string) => {
		try {
			const response = await axios.get(url, { responseType: "blob" });

			const fileURL = URL.createObjectURL(response.data);

			const downloadLink = document.createElement("a");

			downloadLink.href = fileURL;

			downloadLink.download = `${filename}.pdf`;

			downloadLink.click();

			URL.revokeObjectURL(fileURL);
		} catch (error) {
			console.error("Download failed:", error);
		}
	};

	const onHandleOpenModal = useCallback(() => {
		setIsModalOpen(true);
	}, []);

	const onHandleCloseModal = useCallback(() => {
		setIsModalOpen(false);
	}, []);

	//prettier-ignore
	const headerClassname = useMemo(() => (classNames({
		"product-card__header": true,
		"product-card__header--video": Boolean(videoUrl)
	})), [videoUrl]);

	return (
		<div className="app-product-card">
			<div className="product-card">
				<div className="product-card__container">
					<button className={headerClassname} onClick={onHandleOpenModal}>
						{videoUrl && (
							<>
								<div className="product-card__overlay"></div>
								<img className="product-card__icon" src={PlayIcon} alt="playIcon" />
							</>
						)}

						<img className="product-card__image" src={image} alt="productImage" />
					</button>
				</div>

				<div className="product-card__section">
					{/*prettier-ignore*/}
					<p className="product-card__title">{title}</p>

					{/*prettier-ignore*/}
					<p className="product-card__description" title={description}>{description}</p>
				</div>

				{price && priceWithCode && (
					<div className="product-card__wrapper">
						<div className="product-card__box">
							{/*prettier-ignore*/}
							<p className="product-card__label">Without Source Code​</p>
							{/*prettier-ignore*/}
							<p className="product-card__value">{price}</p>
						</div>

						<div className="product-card__box">
							{/*prettier-ignore*/}
							<p className="product-card__label">With Source Code​</p>
							{/*prettier-ignore*/}
							<p className="product-card__value">{priceWithCode}</p>
						</div>
					</div>
				)}
				{fixedPrice && (
					<div className="product-card__wrapper">
						<div className="product-card__box">
							{/*prettier-ignore*/}
							<p className="product-card__value">{fixedPrice}</p>
						</div>
					</div>
				)}

				<AppButton disabled={!link} className="product-card__button" label="Download E-Brochure" onClick={handleClick} tertiary />
			</div>

			<AppClientVideoModal isOpen={isModalOpen} videoUrl={videoUrl} onClose={onHandleCloseModal} />
		</div>
	);
};

export default AppProductCard;
